import React, { useMemo, useState } from 'react';
// import useSentryContext from '../utils/sentryContext';
const ProfileContext = React.createContext();

const ProfileProvider = ({ children }) => {
    const [profileData, set_profileData] = useState({});
    const [clustersData, setClustersData] = useState([]);
    const [projectsData, setProjectsData] = useState([]);

    // const snapshot = useMemo(() => ({
    //     profileData,
    //     clustersData,
    //     projectsData,
    // }), [profileData, clustersData, projectsData]);
    // useSentryContext("profileContext", snapshot);

    return (
        <ProfileContext.Provider value={{ profileData, set_profileData, clustersData, setClustersData, projectsData, setProjectsData }}>
            {children}
        </ProfileContext.Provider>
    );
}

export { ProfileContext, ProfileProvider };